import { Vehicle } from '../../../types/Vehicle';
import { formatServiceArea } from '@/components/ui';
import { fleetStatusLabel } from './equipmentDisplay';
import { unitRoadTypeLabel } from './roadType';
import { AVAILABILITY_LABELS, availabilityState } from '../components/EquipmentStatusPill';

export const EQUIPMENT_CSV_HEADERS = [
    'Unit #',
    'Description',
    'Vehicle Classification',
    'Type',
    'Make',
    'Model',
    'Year',
    'Service Area',
    'Foreman Area',
    'Equipment Status',
    'Availability',
    'Rate',
    'Next PM',
    'Open Defects',
    'Insurance Expiry',
    'Visible to Drivers',
    'Flags'
  ] as const;

/**
 * Client-side CSV export for the Equipment list's "Export CSV" button.
 */
export function exportEquipmentCsv(rows: Vehicle[], filenamePrefix = 'equipment'): void {
  const headers = [...EQUIPMENT_CSV_HEADERS];

  const csvEscape = (value: string): string => {
    if (/[",\n]/.test(value)) {
      return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
  };

  const lines = [headers.map(csvEscape).join(',')];

  rows.forEach(vehicle => {
    const row = [
      vehicle.unitNumber || '',
      vehicle.description || '',
      vehicle.vehicleClassification || '',
      unitRoadTypeLabel(vehicle) ?? '',
      vehicle.make || '',
      vehicle.model || '',
      vehicle.year != null ? String(vehicle.year) : '',
      formatServiceArea(vehicle.vehicleServiceAreas?.[0]?.serviceArea ?? null) ?? '',
      vehicle.foremanArea?.name || '',
      vehicle.status ? fleetStatusLabel(vehicle.status) : '',
      (() => {
        const state = availabilityState(vehicle);
        return state ? AVAILABILITY_LABELS[state] : '';
      })(),
      vehicle.rate != null ? String(vehicle.rate) : '',
      vehicle.nextPMDue != null ? String(vehicle.nextPMDue) : '',
      String(vehicle.openDefectCount ?? 0),
      vehicle.insuranceExpiry ? vehicle.insuranceExpiry.slice(0, 10) : '',
      vehicle.driverVisibility?.visible ? 'Yes' : 'No',
      (vehicle.flags ?? []).map((flag) => flag.detail).join('; ')
    ];

    lines.push(row.map(csvEscape).join(','));
  });

  const csvContent = lines.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  const timestamp = new Date().toISOString().slice(0, 10);
  link.href = url;
  link.download = `${filenamePrefix}-${timestamp}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
